import TextField from "@material-ui/core/TextField";
import DateRangePicker from "react-bootstrap-daterangepicker";
import React, { useState, useEffect } from "react";
import Popover from "@mui/material/Popover";
import Dialog from "@material-ui/core/Dialog";
// you will need the css that comes with bootstrap@3. if you are using
// a tool like webpack, you can do the following:
// import 'bootstrap/dist/css/bootstrap.css';
// you will also need the css that comes with bootstrap-daterangepicker
import "bootstrap-daterangepicker/daterangepicker.css";
import { DateRange } from "@material-ui/icons";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import { makeStyles } from "@material-ui/core/styles";
import DateFnsUtils from "@date-io/date-fns";
import Calendar from "../Calendar";
import "../index.css";
import Hidden from "@material-ui/core/Hidden";
import moment from "moment";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import classes from "./JourneyDate.module.css";

export default function JourneyDate(props) {
  const [showEndDate, setShowEndDate] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleStartChange = (val) => {
    if (props.onStartChange) props.onStartChange(val);
  };

  const handleEndChange = (val) => {
    if (props.onEndChange) props.onEndChange(val);
  };

  useEffect(() => {
    setShowEndDate(props.journeyType == "Return");
  }, [props.journeyType]);

  const handleDateChange = (data) => {
    if (data.length) {
      handleStartChange(data[0]);
      handleEndChange(data[1]);
    } else handleStartChange(data);
    handleClose();
  };

  const onUpdate = (key, button) => {
    let { start, end } = props.value;
    if (start && key == "startDate") {
      if (button == "next") {
        start = moment(start).add(1, "day");
      } else if (button == "prev") {
        start = moment(start).subtract(1, "day");
      }
    } else if (end && key == "endDate") {
      if (button == "next") {
        end = moment(end).add(1, "day");
      } else if (button == "prev") {
        end = moment(end).subtract(1, "day");
      }
    }
    start && handleStartChange(start.toDate());
    end && handleEndChange(end.toDate());
  };

  let value = props.value;

  return (
    <div
      className={`${classes.mydate_picker} mydatepicker`}
      style={{ textAlign: "left" }}
    >
      {showEndDate ? (
        <div className={classes.row}>
          <div
            className={classes["date-picker"]}
            style={{ flexBasis: "50%", padding: "0.5rem 1rem 0.4rem 1rem" }}
            onClick={handleClick}
          >
            <TextField
              type="text"
              style={{ color: "var(--darker)" }}
              inputProps={{ className: classes.textField }}
              placeholder="Departure"
              disablePast={true}
              minDate={
                value.start ? moment(value.start).format("DD/MM/YYYY") : ""
              }
              value={
                value.start
                  ? value.start
                    ? moment(value.start).format("DD/MM/YYYY")
                    : ""
                  : ""
              }
            />
          </div>
          <div
            className={classes["date-picker"]}
            style={{ flexBasis: "50%", padding: "0.5rem 1rem" }}
          >
            <div onClick={handleClick}>
              <TextField
                type="text"
                inputProps={{ className: classes.textField }}
                placeholder="Return"
                value={value.end ? moment(value.end).format("DD/MM/YYYY") : ""}
              />
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="inline-block" style={{ padding: "0.5rem 1rem" }}>
            <div className="inline-block" onClick={handleClick}>
              <div className="single-date-picker">
                <TextField
                  type="text"
                  style={{ width: "100%", fontWeight: 600, fontSize: "14px" }}
                  inputProps={{ className: classes.textField }}
                  placeholder="Start Date"
                  value={
                    value.start
                      ? value.start
                        ? moment(value.start).format("DD/MM/YYYY")
                        : ""
                      : ""
                  }
                />
              </div>
            </div>
          </div>
        </>
      )}
      {(!fullScreen || !showEndDate) && (
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
        >
          <div
            style={{
              backgroundColor: "var(--backgroundcolor)",
              borderRadius: "5px",
              height: "100%",
              width: "100%",
            }}
          >
            <Calendar
              onChange={handleDateChange}
              value={
                showEndDate
                  ? [value.start, value.end]
                  : value.start && value.start
              }
              showTwoMonths={showEndDate}
              showRange={showEndDate}
              query={props.query}
            />
          </div>
        </Popover>
      )}
      {fullScreen && showEndDate && (
        <Dialog fullScreen open={open} onClose={handleClose}>
          <div
            style={{
              backgroundColor: "var(--backgroundcolor)",
              borderRadius: "5px",
              height: "100%",
              width: "100%",
            }}
          >
            <Calendar
              onChange={handleDateChange}
              value={
                showEndDate
                  ? [value.start, value.end]
                  : value.start && value.start
              }
              showTwoMonths={showEndDate}
              showRange={showEndDate}
              query={props.query}
            />
          </div>
        </Dialog>
      )}
    </div>
  );
}
